module.exports = __webpack_public_path__ + "media/images/flags/KM-fe5a024a00a91c44a96600276e815614.svg";